<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-tab-pane v-for="(item,type) in typeArr" :name="type" :label="item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8">
                <CommonExcel ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
                <clear-cache-apply url="/config/activity-auxiliary/bridgeGame" />
              </el-row>
            </div>
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%" height="600">
              <el-table-column label="序号" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template slot-scope="{row,$index}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  <el-button type="success" size="mini" @click="handleCopy(row)">拷贝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig(type)">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog :show-close="false" :before-close="handleClose" title="提示" :visible.sync="dialog" width="60%">
        <el-table :key="tableKey" size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="type == 1">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="阶段" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.stage" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column label="转弯(0/1)" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.swerve" placeholder="转弯" />
              </template>
            </el-table-column>
            <el-table-column label="中心点额外倍数" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.bet" placeholder="中心点额外倍数" />
              </template>
            </el-table-column>
            <el-table-column label="奖励" align="center">
              <template slot-scope="scope">
                <Reward v-model="scope.row.reward" :limit-len="1" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type == 2">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="价格" align="center">
              <Price />
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type == 3">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="格子范围(min)" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input-number v-model="row.gridMin" :controls="false" placeholder="间距(min)" />
              </template>
            </el-table-column>
            <el-table-column label="格子范围(max)" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input-number v-model="row.gridMax" :controls="false" placeholder="间距(max)" />
              </template>
            </el-table-column>
            <el-table-column label="权重" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input-number v-model="row.weight" :controls="false" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column label="间距范围(min)" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input-number v-model="row.distanceMin" :controls="false" placeholder="间距(min)" />
              </template>
            </el-table-column>
            <el-table-column label="间距范围(max)" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input-number v-model="row.distanceMax" :controls="false" placeholder="间距(max)" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type == 4">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="背景" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.background" placeholder="背景" />
              </template>
            </el-table-column>
            <el-table-column label="权重" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.v" placeholder="权重" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type == 5">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="倍率" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.bet" placeholder="倍率" />
              </template>
            </el-table-column>
            <el-table-column label="系数" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.coef" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button type="primary" @click="addRewardDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import Price from '@/components/Price'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'

export default {
  name: 'ActBridgeGame',
  components: { Price, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      tableKey: 0,
      curClass: 'bridge_game',
      loading: false,
      dialog: false,
      diaLogList: [],
      list: [],
      type: 1,
      typeArr: { 1: '地图配置', 2: '商品配置', 3: '间距配置', 4: '背景配置', 5: '倍率系数配置' }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    openDialog(config) {
      this.tableKey++
      if (!config) {
        config = []
      }
      this.diaLogList = config
      this.dialog = true
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id !== 0) {
          delActAuxiliary({ idList: [id] }).then(res => {
            this.list[this.type].splice(index, 1)
          })
        }
        this.list[this.type].splice(index, 1)
      })
    },
    handleCopy(row) {
      const _row = Object.assign({}, row)
      _row.id = 0
      this.list[this.type].push(_row)
    },
    handleAdd(type, name, config) {
      if (!config) {
        config = []
      }
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name == sheet) {
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => { this.getList() }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      const fileName = this.typeArr[type]
      const hearer = []
      const excelData = []
      const tranTitle = {
        1: { stage: '阶段', swerve: '转弯', bet: '中心点额外倍数', reward: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}},
        2: { mtype: '类型', sku: '库存', bet: '倍数', price: '价格' },
        3: { gridMin: '格式范围(Min)', gridMax: '格式范围(Max)', weight: '权重', distanceMin: '间距范围(Min)', distanceMax: '间距范围(Max)' },
        4: { background: '背景', v: '权重' },
        5: { bet: '倍率', coef: '系数' }
      }[type]
      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef[type - 1].makeExcelData(dataArr[i], tranTitle)
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addRewardDialogList() {
      if (this.type == 1) {
        this.diaLogList.push({ stage: 1, swerve: 0, bet: 0, reward: [] })
      } else if (this.type == 2) {
        this.diaLogList.push({ mtype: 1, bet: 1, sku: '', price: 0, coin: 'money1' })
      } else if (this.type == 3) {
        this.diaLogList.push({ gridMin: 1, gridMax: 1, weight: 1, distanceMin: 1, distanceMax: 1 })
      } else if (this.type == 4) {
        this.diaLogList.push({ background: 1, v: 1 })
      } else if (this.type == 5) {
        this.diaLogList.push({ bet: 1, coef: 1 })
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    }
  }
}
</script>

